export default __webpack_public_path__ + "0d96c91f110ff213bb97b6b661521766.png";